import { useSelector } from "react-redux";
import MdmSetUp from "./mdmSetUp";
import MdmColumnSetUp from "./mdmColumnSetUp";
import MdmFormSetUp from "./mdmFormSetUp";
import { useEffect, useState } from "react";
import { ExcelColumns, formConfig, initialCards } from "./mdmUtils";
import { setFormConfig, updateCards } from "../../stateManagement/actions/mdmDashboard";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { Loader } from "../../components/loader/Loader";

export const MdmSetUpDashboard = ({
  domainTypePrefix,
  importFromBase = false,
  importFromRole
}: {
  domainTypePrefix?: string;
  importFromBase?: boolean;
  importFromRole?: string;
}) => {
  const currentStep = useSelector((state: any) => state.mdmDashboardReducer.currentStep);
  const [excelMasterColumns, setExcelMasterColumns] = useState<ExcelColumns>({});
  const [cardsLoading, setCardsLoading] = useState<boolean>(true);
  const [formConfigLoading, setFormConfigLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchInitialCards = async () => {
      try {
        if (importFromBase) {
          updateCards(initialCards);
          setCardsLoading(false);
          return;
        }

        const sourceRole = importFromRole || domainTypePrefix || "admin";
        const roleDomainType = `${sourceRole}_generic_mdm_configuration`;

        const response = await getMetaDataConfig("clientconfig", roleDomainType);

        if (response?.domainValues?.length > 0) {
          updateCards(response.domainValues);
        } else {
          updateCards(initialCards);
        }
      } catch (error) {
        console.error("Error fetching cards:", error);
        updateCards(initialCards);
      } finally {
        setCardsLoading(false);
      }
    };
    fetchInitialCards();
  }, [domainTypePrefix, importFromBase, importFromRole]);

  useEffect(() => {
    const fetchInitialFormConfig = async () => {
      try {
        if (importFromBase) {
          setFormConfig(formConfig);
          setFormConfigLoading(false);
          return;
        }

        const sourceRole = importFromRole || domainTypePrefix;

        if (!sourceRole) {
          updateCards(initialCards);
          setCardsLoading(false);
          return;
        }
        const roleDomainType = `${sourceRole}_form_configuration`;

        const response = await getMetaDataConfig("clientconfig", roleDomainType);

        if (response?.domainValues?.length > 0) {
          setFormConfig(response.domainValues);
        } else {
          setFormConfig(formConfig);
        }
      } catch (error) {
        console.error("Error fetching formConfig:", error);
        setFormConfig(formConfig);
      } finally {
        setFormConfigLoading(false);
      }
    };
    fetchInitialFormConfig();
  }, [domainTypePrefix, importFromBase, importFromRole]);

  const isLoading = cardsLoading || formConfigLoading;

  if (isLoading) {
    return <Loader />;
  }

  if (currentStep === 1) {
    return <MdmSetUp />;
  }

  if (currentStep === 2) {
    return <MdmColumnSetUp setExcelMasterColumns={setExcelMasterColumns} />;
  }

  if (currentStep === 3) {
    return <MdmFormSetUp excelMasterColumns={excelMasterColumns} domainTypePrefix={domainTypePrefix} />;
  }

  return null;
};